export const DISPLAY_EVENT_PRICE_DETAILS_MODAL_SHARED = 'DISPLAY_EVENT_PRICE_DETAILS_MODAL_SHARED';
export const CANCEL_EVENT_PRICE_DETAILS_MODAL_SHARED = 'CANCEL_EVENT_PRICE_DETAILS_MODAL_SHARED';
export const SET_EVENT_PRICE_DETAILS_DATA_SHARED = 'SET_EVENT_PRICE_DETAILS_DATA_SHARED';



// WEBPACK FOOTER //
// ./src/features/shared/eventPriceDetailsModal/constants.js